import {message} from 'antd';
import i18next from "../i18n";
import responseStatuses from "./responseStatuses";
import keycloak from '../keycloak'

const apiPoint: string = process.env.REACT_APP_API_ENTRYPOINT || ''

export interface HydraData {
  data: any[] | any,
  total: Number,
}

export const api = {
  fetch: function (url: string) {
    return fetch(apiPoint + url, {
      headers: {
        Authorization: ` Bearer ${keycloak.token}`
      }
    })
  },
  get: function (url: string) {
    return fetch(apiPoint + url, {
      headers: {
        Authorization: ` Bearer ${keycloak.token}`
      }
    }).then(responseHandler).then(response => {
      let data: HydraData = {
        data: [],
        total: 0,
      }

      if (response['hydra:member']) {
        data.data = response['hydra:member']
      } else {
        data.data = response
      }

      if (response['hydra:totalItems'] !== undefined) {
        data.total = response['hydra:totalItems']
      }

      return data
    })
  },
  post: function (url: string, {arg}: { arg: any }) {
    const options: RequestInit = {
      method: "POST",
      body: JSON.stringify(arg),
      headers: {},
    }

    //if (toJson) {
    options.headers = {"Content-Type": "application/ld+json"}
    //}

    if (url !== '/authentication_token') {
      options.headers.Authorization = ` Bearer ${keycloak.token}`
    }

    return fetch(apiPoint + url, options)
    .then(responseHandler)
  },
  postFile: function (url: string, {arg}: { arg: any }) {
    const options: RequestInit = {
      method: "POST",
      body: arg,
    }

    options.headers = {}

    if (url !== '/authentication_token') {
      options.headers.Authorization = ` Bearer ${keycloak.token}`
    }

    return fetch(apiPoint + url, options)
    .then(responseHandler)
  },
  patch: function (url: string, {arg}: { arg: any }) {
    return fetch(apiPoint + url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/merge-patch+json",
        Authorization: ` Bearer ${keycloak.token}`
      },
      body: JSON.stringify(arg)
    })
    .then(responseHandler)
  },
  put: function (url: string, body: string) {
    return fetch(apiPoint + url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/ld+json",
        Authorization: ` Bearer ${keycloak.token}`
      },
      body: JSON.stringify(body)
    }).then(responseHandler)

  },

  delete: function (url: string) {
    return fetch(apiPoint + url, {
      method: "DELETE",
      headers: {
        Authorization: ` Bearer ${keycloak.token}`
      },
    }).then(responseHandler)
  },
  getFile: async function (url: string) {
    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${keycloak.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Ошибка ${response.status}: ${response.statusText}`);
      }

      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'download';

      if (contentDisposition) {
        filename = getFilenameFromContentDisposition(contentDisposition);
      }

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = blobUrl;
      link.download = filename;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.error('Ошибка при скачивании:', error);
    }
  }
};

function getFilenameFromContentDisposition(contentDisposition: string): string {
  if (!contentDisposition) {
    return '';
  }

  const filenameStarMatch = contentDisposition.match(/filename\*=utf-8''([^;]+)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    try {
      return decodeURIComponent(filenameStarMatch[1]);
    } catch (error) {
      return '';
    }
  }

  const filenameMatch = contentDisposition.match(/filename=([^;]+|"[^"]+")/i);

  if (!filenameMatch?.[1]) {
    return '';
  }

  let filename = filenameMatch[1].trim();

  if (filename.startsWith('"') && filename.endsWith('"')) {
    filename = filename.slice(1, -1);
  } else if (filename.startsWith("'") && filename.endsWith("'")) {
    filename = filename.slice(1, -1);
  }

  return filename;
}

export const responseHandler = (response: Response) => {
  if (response.status === responseStatuses.UNAUTHORIZED_STATUS) {
    keycloak.logout()
  }

  if (response.status === responseStatuses.NO_CONTENT_STATUS) {
    return Promise
    .resolve(true)
  }

  if (
    response.status >= responseStatuses.OK_STATUS
    && response.status < responseStatuses.BAD_REQUEST_STATUS
  ) {
    return Promise
    .resolve(response.json())
  }

  if (response.status >= responseStatuses.SERVER_ERROR_STATUS) {
    //message.error(i18next.t('errors.server_error'))
    return Promise
    .resolve(response.json())
    .then((responseInJson) => {
      return Promise.reject(responseInJson)
    })
  }

  if (response.status === responseStatuses.DENIED_STATUS) {
    message.error(i18next.t('errors.access_denied'))

    return Promise
    .reject('')
  }

  if (response.status === responseStatuses.NOT_FOUND_STATUS) {
    message.error(i18next.t('errors.not_found'))

    return Promise
    .reject('')
  }

  if (
    response.status >= responseStatuses.BAD_REQUEST_STATUS
    && response.status < responseStatuses.SERVER_ERROR_STATUS
  ) {
    return Promise
    .resolve(response.json())
    .then((responseInJson) => {
      return Promise.reject(responseInJson)
    })
  }
}
